// extracted by mini-css-extract-plugin
export default {"iconWrapper":"IconCmp_iconWrapper__k+34K"};